import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const PlaceholderTile = () => (
    <div className='relative h-full overflow-hidden cursor-pointer select-none p-[1px] flex'>
        <div className='flex items-center justify-center flex-1 dashed-border hover:bg-tileBackground text-textDisabled hover:text-textPrimary'>
            <FontAwesomeIcon icon={faPlus} className='size-[26px]' />
        </div>
    </div>
);
